import { State } from 'interfaces/state'
import { createSelector } from 'reselect'
import { LineChart, LineChartInnerOwnProps, LineChartInnerStateProps } from 'components/features/pfm/LineChart/LineChart'
import LineChartLoadingOverlay from 'components/atoms/preloaders/LineChartLoadingOverlay'
import { AccountTyped } from 'interfaces/accounts'
import { Guards } from 'interfaces/guards'
import { connectShadedLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { memberAccountTrendsGuard, peergroupAccountTrendsGuard } from 'guards/accountGuards'
import { memberAccountTrendSelector, yourPeersAccountTrendsSelector, othersAccountTrendsSelector } from 'selectors/accountSelectors'
import { createOwnPropsSelector } from 'selectors/globalSelectors'
import { AccountPage } from 'interfaces/pages'
import { CategoryId } from 'interfaces/meta'
import { Timeframe } from 'interfaces/chart'

import { prepareTrendProps } from 'helpers/trendHelpers'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { isMobileSelector } from 'selectors/viewportSelectors'
import { selectedRelationSelector } from 'selectors/peergroupSelectors'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

export type AccountTrendOwnProps = {
  type: AccountPage
  timeframe: Timeframe
  categoryId: CategoryId
}

type OwnProps =
  & AccountTrendOwnProps
  & LineChartInnerOwnProps

const createMapStateToProps = () =>
  createSelector(
    memberAccountTrendSelector,
    yourPeersAccountTrendsSelector,
    othersAccountTrendsSelector,
    selectedRelationSelector,
    isMobileSelector,
    createOwnPropsSelector<OwnProps>(),
    withComparisonSelector,
    (memberTrend, peersTrend, othersTrend, selectedRelation, isMobile, ownProps, withComparison) => {
      if (!peersTrend || !othersTrend) {
        throw createForgottenGuardError('AccountsTrendModuleContainer', 'peergroupAccountTrendsGuard')
      }

      if (!selectedRelation) {
        throw createForgottenGuardError('AccountsTrendModuleContainer', 'peergroupsGuard')
      }

      return prepareTrendProps({ memberTrend, peersTrend, othersTrend }, ownProps, selectedRelation.name, isMobile, withComparison)
    }
  ) as (state: State, ownProps: OwnProps) => LineChartInnerStateProps

const guards: Guards<AccountTyped> = [
  peergroupsGuard,
  createParallelGuard(memberAccountTrendsGuard, peergroupAccountTrendsGuard),
]

export default connectShadedLoadable<
  LineChartInnerStateProps,
  {},
  LineChartInnerOwnProps,
  OwnProps
>(createMapStateToProps, undefined, guards, LineChartLoadingOverlay)(LineChart)
